module.exports = function getMeta(metaName, defaultValue = null) {
    const meta = document.querySelector('meta[name="' + metaName + '"]');
    if (meta) return meta.getAttribute('content') || defaultValue;
    return defaultValue;
};
